import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import IconCaretUp from '@vtex/styleguide/lib/icon/CaretUp'
import IconCaretDown from '@vtex/styleguide/lib/icon/CaretDown'

function SummaryTitle({ showDetails, onClick, rightElement }) {
  return (
    <button
      className={`flex flex-shrink-0 bg-white bw1 bw0-l pointer br-0 bl-0 b--muted-5 tc pa5 lh-copy dn-l f5 justify-between w-100 ${
        showDetails ? 'bt-0' : 'bb-0'
      }`}
      id="summary-identification"
      onClick={onClick}
    >
      <div className="mt2">
        <span className="c-action-primary mr4">
          {showDetails ? <IconCaretDown /> : <IconCaretUp />}
        </span>
        <FormattedMessage id="summary.orderSummary" />
      </div>
      <div id="cartsummary-price" className="flex-none f4">
        {rightElement}
      </div>
    </button>
  )
}

SummaryTitle.propTypes = {
  showDetails: PropTypes.bool,
  onClick: PropTypes.func,
  rightElement: PropTypes.node,
}

export default SummaryTitle
